<template>
<div class="linelist" v-if="isShow">
	<div class="f-l fdqy-c p5 fdqx-b">
		<p v-if="!showbox" class="pl5 fs14">传输列表</p>
		<div class="pl5 pt5" id="linelist" v-if="showbox">
			<el-button size="mini" :type="showlist==='up'?'primary':''" @click="showlist='up'">上传列表</el-button>
			<el-button size="mini" :type="showlist==='down'?'primary':''" @click="showlist='down'">下载列表</el-button>
		</div>
		<p><el-button :icon="showbox?'el-icon-download':'el-icon-upload2'" circle size="mini" @click="showbox=!showbox"></el-button></p>
	</div>
	<div v-if="showbox" class="box">
		<div class="listbox" :style="{display:showlist==='up'?'block':'none'}">
			<line-item v-for="(item,index) in getLineList['up']" :key="'line'+index" :test="item" type="up"></line-item>
		</div>
		<div class="listbox" :style="{display:showlist==='down'?'block':'none'}">
			<line-item v-for="(item,index) in getLineList['down']" :key="'line'+index" :test="item" type="down"></line-item>
		</div>
	</div>
</div>
</template>

<script>
import LineItem from "../../components/lineitem.vue"
import { mapGetters} from 'vuex'
export default{
	name:'linelist',
	data() {
		return {
			showbox:true,
			showlist:"up",
		}
	},
	computed:{
		...mapGetters('Library',['getLineList']),
		isShow(){
			if(this.getLineList.up.length===0&&this.getLineList.down.length===0){
				return false
			}
			return true
		},
	},
	watch:{
		isShow(n){
			if(!n){
				return
			}
			if(this.getLineList.up.length!==0){
				this.showlist="up"
				return
			}
			this.showlist="down"
		}
	},
	components:{
		LineItem
	},
	
}
</script>

<style scoped>
.linelist{
	position: fixed;
	right: 15px;
	bottom: 15px;
	z-index: 99;
	width: 300px;
	background: #e49536;
	border-radius: 10px;
	overflow: hidden;
}
.linelist:hover{
	box-shadow: -5px -5px 5px #999999;
}
#linelist .el-button{
	padding: 5px 7px;
}
.box{
	padding-bottom: 8px;
	background: #fff;
	margin: 0px 2px 2px 2px;
	border-radius: 0px 0px 8px 8px;
}
.listbox{
	height: 350px;
	overflow-y: scroll;
}

</style>
